class MetafieldData extends HTMLElement {
    constructor() {
        super();
        
        this.togglebutton = this.querySelector('.show-toggle button');
        this.togglediv = this.querySelector('.toggle-div');
        
        this.togglebutton.addEventListener('click', this.toggleEvent.bind(this));
        console.log(this.togglebutton);
    }

    toggleEvent() {
        this.togglebutton.classList.toggle("opened");
        this.togglediv.classList.toggle("opened");
    }

}

customElements.define('data-from-metafield', MetafieldData);

class FreezeDrawer extends HTMLElement {
    constructor() {
        super();

        this.triggerButton = this.querySelector('.freeze-icons');
        this.togglediv = this.querySelector('.freeze-drawer');
        this.close = this.querySelector('.close');

        this.triggerButton.addEventListener('click', this.toggleEvent.bind(this));
        this.close.addEventListener('click', this.toggleEvent.bind(this));
    }

    toggleEvent() {
        this.togglediv.classList.toggle('active');
    }
}

customElements.define('freeze-drawer', FreezeDrawer);